// @flow
import haWrapper from '../utils/haWrapper';
import {post} from '../utils/fetchWrapper';
import clientLogger from './clientLogger';

// There are more EntryTypes in the spec, but these are the ones we know are
// supported by Safari
type PerformanceEntryType = 'mark' | 'measure' | 'resource';

type PARLogData = {
    duration: number,
    referrer: string
};

// Performance data suitable for being POSTed to the /api/metrics endpoint
export type PerformanceLogData = {
    primaryActionRendered?: PARLogData,
    [string]: number
};

export function getLoadTimeAnalytics(
    measureName: string,
    measureType: PerformanceEntryType
): PerformanceEntry | null {
    const loadTimeAnalytics = haWrapper.userTiming.getEntriesByName(
        measureName,
        measureType
    );
    if (loadTimeAnalytics && loadTimeAnalytics[0]) {
        return loadTimeAnalytics[0];
    }
    clientLogger.captureMessage('loadTimeAnalytics undefined', {
        level: 'info',
        tags: {
            measureName
        }
    });
    return null;
}

export function sendCustomAnalytics(
    measureName: string,
    measureType: PerformanceEntryType,
    payloadFactory: (PerformanceEntry) => PerformanceLogData
) {
    // get the analytics
    const loadTimeAnalytics = getLoadTimeAnalytics(measureName, measureType);

    if (loadTimeAnalytics) {
        const urlPrefix = haWrapper.urlPrefix;
        post(`/${urlPrefix}/api/metrics`, payloadFactory(loadTimeAnalytics));
        return;
    }
    return;
}
